import api from './axios';

const subscriptionsApi = {
  getInfo: () => api.get('/subscriptions/info'),
  getControlCenter: () => api.get('/subscriptions/control-center'),
  extendTrial: (orgId, days) => api.patch(`/subscriptions/extend-trial/${orgId}`, { days }),
  updatePlan: (plan) => api.patch('/subscriptions/plan', { plan }),
  getPayments: () => api.get('/subscriptions/payments'),
  createPayment: (data) => api.post('/subscriptions/payments', data),
  createPaypalOrder: (plan) => api.post('/subscriptions/paypal/create-order', { plan }),
  capturePaypalOrder: (orderId, plan) => api.post('/subscriptions/paypal/capture-order', { orderId, plan }),
  cancelSubscription: () => api.post('/subscriptions/cancel'),
  getInvoiceUrl: (paymentId) => `/subscriptions/invoice/${paymentId}`
};

export default subscriptionsApi;
